/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_1_DescInputs */

const es_home_features_item_1_desc = /** @type {(inputs: Home_Features_Item_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiende consultas en lenguaje natural, no solo palabras clave exactas.`)
};

const en_home_features_item_1_desc = /** @type {(inputs: Home_Features_Item_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understands natural language queries, not just exact keywords.`)
};

/**
* | output |
* | --- |
* | "Understands natural language queries, not just exact keywords." |
*
* @param {Home_Features_Item_1_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_1_desc = /** @type {((inputs?: Home_Features_Item_1_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_1_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_1_desc(inputs)
	return en_home_features_item_1_desc(inputs)
});
export { home_features_item_1_desc as "home.features.item_1_desc" }